<template>
    <div class="col-md-9">
        <h1 class="pages__title">menus</h1>
        <div class="pages__table">
            <div class="pages__top">
                <div class="title-page">
                    Title
                </div>
                <div class="action">
                    Action
                </div>
            </div>
            <ul class="pages__list">
                <li
                    class="pages__line"
                    v-for="menu in listOfMenus"
                    :key="menu.id"
                >
                    <div class="title-page">
                       {{ menu.name}}
                    </div>
                    <div class="action">
                        <div class="action__hold">
                            <a :href="`/admin/panel/menus/${menu.id}/edit`"  class="build">
                                <svg width="16" height="16" aria-hidden="true">
                                    <use href="/img/svg/build.svg#icon-build"></use>
                                </svg>
                            </a>
                            <a href="javascript:void(0)" class="edit" @click="openEditModal(menu)" >
                                <svg width="16" height="16" aria-hidden="true">
                                    <use href="/img/svg/symbol-defs.svg#icon-edit"></use>
                                </svg>
                            </a>
                            <a
                                href="javascript:void(0)"
                                class="delete"
                                @click="openDeleteModal(menu)"
                            >
                                <svg width="16" height="16" aria-hidden="true">
                                    <use href="/img/svg/symbol-defs.svg#icon-close-9"></use>
                                </svg>
                            </a>
                        </div>
                    </div>
                </li>
            </ul>
            <ActionModal
                v-if="currentMenu"
                :modal-id="getCustomModalId('delete',currentMenu.id)"
                @confirm="deleteMenu(currentMenu.id)"
                :reject-text="`No`"
                :confirm-text="`Yes`"
            >
                <template #body>
                    <div class="text-center mb-4">
                        <div class="text-center">
                            <h5 class="title">Are you sure ?</h5>
                            <p>Do you want to delete this page?</p>
                        </div>
                    </div>
                </template>
            </ActionModal>

            <ActionModalWithInput
                v-if="currentMenu"
                :modal-id="getCustomModalId('edit', currentMenu.id)"
                :title="currentMenu.name"
                :reject-text="`No`"
                :confirm-text="`Yes`"
                @confirm="updateMenuTitle"
            />
        </div>
    </div>
</template>

<script>
import {defineComponent} from 'vue'
import AdminPanelService from "../../../services/AdminPanelService";
import ActionModal from "../../Common/ActionModal.vue";
import ModalHandler from "../../../mixins/ModalHandler";
import ActionModalWithInput from "../../Common/ActionModalWithInput.vue";

export default defineComponent({
    name: "Menus",
    components: {ActionModalWithInput, ActionModal},
    mixins: [ModalHandler],
    data() {
        return {
            listOfMenus: [],
            currentMenu: null,
        }
    },
    methods: {
        async updateMenuTitle(title) {
            try {
                await AdminPanelService.changeMenuTitle(this.currentMenu.id, title)
                await this.fetchListOfMenus()
            } catch (e) {
            }
        },
        async fetchListOfMenus() {
            try {
                const { data: response } = await AdminPanelService.fetchListOfMenus()
                this.listOfMenus = response
            } catch (e) {
                console.log(e)
            }
        },
        openEditModal(menu) {
            this.currentMenu = menu
            this.$nextTick(()=> {
                this.showCustomModal('edit', menu.id)
            })
        },
        openDeleteModal(menu) {
            this.currentMenu = menu
            this.$nextTick(()=> {
                this.showCustomModal('delete', menu.id)
            })
        },
        async deleteMenu(menuId) {
            try {
                await AdminPanelService.deleteMenu(menuId)
            } catch (e) {
                console.error(e)
                this.$showErrorMessage('The Menu was not deleted. Please try again')
            }
        }
    },
    mounted() {
        this.fetchListOfMenus()
    }
})
</script>


<style scoped>

</style>
